module.exports = __webpack_public_path__ + "img/27.8c3cec00.png";